"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSort(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M17.5 13.75a.75.75 0 01.618 1.175l-5.5 8a.75.75 0 01-1.236 0l-5.5-8A.75.75 0 016.5 13.75zm-1.427 1.5H7.925l4.074 5.926 4.074-5.926zm-4.69-14.175a.75.75 0 011.236 0l5.5 8a.75.75 0 01-.618 1.175h-11a.75.75 0 01-.618-1.175zM12 2.823L7.925 8.75h8.15L12 2.823z"
  }));
}

var _default = SvgSort;
exports.default = _default;